// const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
// const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
// const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
// const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// function applyHomepageSectionAnimations(rootEl = document) {
//   if (!document.body.classList.contains('template-index')) return;

//   let targets = [];

//   if (rootEl.classList && rootEl.classList.contains('shopify-section')) {
//     targets = [rootEl];
//   } else {
//     const main =
//       rootEl.id === 'MainContent' ? rootEl : document.getElementById('MainContent');
//     if (main) {
//       targets = Array.from(main.children).filter((el) => el.classList.contains('shopify-section'));
//     } else if (rootEl.querySelectorAll) {
//       targets = Array.from(rootEl.querySelectorAll('.shopify-section'));
//     }
//   }

//   targets.forEach((section, index) => {
//     if (section.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) return;

//     section.classList.add(
//       SCROLL_ANIMATION_TRIGGER_CLASSNAME,
//       // 'animate--slide-in',
//         'animate--home-reveal',
//       SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
//     );
//     section.style.setProperty('--animation-order', String(index % 5));
//   });
// }

// // Scroll in animation logic
// function onIntersection(elements, observer) {
//   elements.forEach((element, index) => {
//     if (element.isIntersecting) {
//       const elementTarget = element.target;
//       if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
//         elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//         if (elementTarget.hasAttribute('data-cascade'))
//           elementTarget.setAttribute('style', `--animation-order: ${index};`);
//       }
//       observer.unobserve(elementTarget);
//     } else {
//       element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//       element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
//     }
//   });
// }

// function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
//   const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
//   if (animationTriggerElements.length === 0) return;

//   if (isDesignModeEvent) {
//     animationTriggerElements.forEach((element) => {
//       element.classList.add('scroll-trigger--design-mode');
//     });
//     return;
//   } 
//    const isHomepage = document.body.classList.contains('template-index');
//   const observer = new IntersectionObserver(onIntersection, {
//     // rootMargin: '0px 0px -50px 0px',
//      rootMargin: isHomepage ? '0px 0px 5% 0px' : '0px 0px -50px 0px',
//     threshold: isHomepage ? 0.05 : 0,
        
//   });
//   animationTriggerElements.forEach((element) => observer.observe(element));
// }

// // Zoom in animation logic
// function initializeScrollZoomAnimationTrigger() {
//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

//   const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

//   if (animationTriggerElements.length === 0) return;

//   const scaleAmount = 0.2 / 100;

//   animationTriggerElements.forEach((element) => {
//     let elementIsVisible = false;
//     const observer = new IntersectionObserver((elements) => {
//       elements.forEach((entry) => {
//         elementIsVisible = entry.isIntersecting;
//       });
//     });
//     observer.observe(element);

//     element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

//     window.addEventListener(
//       'scroll',
//       throttle(() => {
//         if (!elementIsVisible) return;

//         element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
//       }),
//       { passive: true }
//     );
//   });
// }

// function percentageSeen(element) {
//   const viewportHeight = window.innerHeight;
//   const scrollY = window.scrollY;
//   const elementPositionY = element.getBoundingClientRect().top + scrollY;
//   const elementHeight = element.offsetHeight;

//   if (elementPositionY > scrollY + viewportHeight) {
//     // If we haven't reached the image yet
//     return 0;
//   } else if (elementPositionY + elementHeight < scrollY) {
//     // If we've completely scrolled past the image
//     return 100;
//   }

//   // When the image is in the viewport
//   const distance = scrollY + viewportHeight - elementPositionY;
//   let percentage = distance / ((viewportHeight + elementHeight) / 100);
//   return Math.round(percentage);
// }

// window.addEventListener('DOMContentLoaded', () => {
//    applyHomepageSectionAnimations();
//   initializeScrollAnimationTrigger();
//   initializeScrollZoomAnimationTrigger();
// });

// if (Shopify.designMode) {
//   // document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
//   // document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
//    document.addEventListener('shopify:section:load', (event) => {
//     applyHomepageSectionAnimations(event.target);
//     initializeScrollAnimationTrigger(event.target, true);
//   });
//   document.addEventListener('shopify:section:reorder', () => {
//     applyHomepageSectionAnimations();
//     initializeScrollAnimationTrigger(document, true);
//   });
// }
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

const HOME_CONTENT_SELECTORS = [
  'img',
  'video',
  'h1',
  'h2',
  'h3',
  'h4',
  'p',
  '.button',
  'a.button',
  '[class*="__button"]',
  '[class*="__heading"]',
  '[class*="__text"]',
  '.luxury-card',
  '.cat-grid__card',
  '.card-wrapper',
  '.blog__post',
  '.category-circle-slider__item',
  '.flash-sale-timer__inner',
  '.featured-tabs__nav',
  '.review-section__card',
  '.custom-social__item',
].join(',');

const HOME_EXCLUDE_ANCESTORS = '.marquee-bar, .marquee-track, .marquee-wrapper, .top-bar, .slider-buttons, .slideshow__controls';

const HOME_CARD_ANCESTORS = '.luxury-card, .cat-grid__card, .card-wrapper, .blog__post, .custom-social__item, .review-section__card';

const HOME_EXCLUDE_SECTIONS = '.coll-hero__banner, .slideshow, .banner, .find-us';

function shouldAnimateContentElement(el) {
  if (!el || el.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) return false;
  if (el.closest(HOME_EXCLUDE_SECTIONS)) return false;
  if (el.closest(HOME_EXCLUDE_ANCESTORS)) return false;
  if (el.tagName === 'IMG' && el.closest(HOME_CARD_ANCESTORS)) return false;
  if (el.tagName === 'IMG' && el.closest('picture')) return false;
  if (el.tagName === 'P' && el.closest('[class*="__text"], .rte, .coll-hero__text')) return false;
  if (el.tagName === 'IMG') {
    const w = el.naturalWidth || el.offsetWidth;
    const h = el.naturalHeight || el.offsetHeight;
    if (w > 0 && w < 48 && h > 0 && h < 48) return false;
  }
  return true;
}

function applyHomepageContentAnimations(rootEl = document) {
  if (!document.body.classList.contains('template-index')) return;

  const sections = [];

  if (rootEl.classList && rootEl.classList.contains('shopify-section')) {
    sections.push(rootEl);
  } else {
    const main = rootEl.id === 'MainContent' ? rootEl : document.getElementById('MainContent');
    if (main) {
      sections.push(...Array.from(main.children).filter((el) => el.classList.contains('shopify-section')));
    } else if (rootEl.querySelectorAll) {
      sections.push(...rootEl.querySelectorAll('.shopify-section'));
    }
  }

  sections.forEach((section) => {
    if (section.querySelector('.coll-hero__banner, .slideshow, .banner--large')) return;

    const elements = section.querySelectorAll(HOME_CONTENT_SELECTORS);
    let order = 0;

    elements.forEach((el) => {
      if (!shouldAnimateContentElement(el)) return;

      const isMedia = el.tagName === 'IMG' || el.tagName === 'VIDEO';
      el.classList.add(
        SCROLL_ANIMATION_TRIGGER_CLASSNAME,
        'animate--home-content',
        isMedia ? 'animate--home-media' : 'animate--home-text',
        SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
      );
      el.style.setProperty('--animation-order', String(Math.min(order, 6)));
      order += 1;
    });
  });
}

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const isHomepage = document.body.classList.contains('template-index');
  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: isHomepage ? '0px 0px 10% 0px' : '0px 0px -50px 0px',
    threshold: isHomepage ? 0.08 : 0,
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  applyHomepageContentAnimations();
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    applyHomepageContentAnimations(event.target);
    initializeScrollAnimationTrigger(event.target, true);
  });
  document.addEventListener('shopify:section:reorder', () => {
    applyHomepageContentAnimations();
    initializeScrollAnimationTrigger(document, true);
  });
}
